/**
 * Created by Jerker Nord on 2020-06-01.
 */
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {TimelineLite} from "gsap";
import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {MonkeysGoldSoundConfig} from "../../MonkeysGoldSoundConfig";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";

export class SpineScatterSymbol extends PIXI.Container {

    private _scatterSymbol:StateReelSymbol;
    private _symbolOffset:PIXI.Point = new PIXI.Point(0, 89.8);
    private _yPos:number;
    private _spineScatterSymbol:PIXI.spine.Spine;
    private _spineScatterGreenFrames:PIXI.spine.Spine;
    private _spineScatterPlus:PIXI.spine.Spine;
    private _level3Enabled:boolean = false;
    private _scatterLevel:number = 0;
    private _yellowBlast:TimelineSprite;

    constructor(spineData:PIXI.spine.core.SkeletonData) {
        super();
        this._spineScatterSymbol = new PIXI.spine.Spine(spineData);
        this.addChild(this._spineScatterSymbol);
        this.position.y = this._symbolOffset.y;

        this._spineScatterGreenFrames = new PIXI.spine.Spine(GameResources.getSpineAsset("spineBonusSymbolFrame"));
        this._spineScatterGreenFrames.visible = false;
        this.addChild(this._spineScatterGreenFrames);

        this._yellowBlast = new TimelineSprite(GameResources.getTextures("Bonus Anticipation/yellow blast/yellow_blast_"));
        //this._yellowBlast.blendMode = PIXI.BLEND_MODES.ADD;
        this._yellowBlast.anchor.set(0.5, 0.5);
        this._yellowBlast.hide();
        this.addChild(this._yellowBlast);

        this._spineScatterPlus = new PIXI.spine.Spine(GameResources.getSpineAsset("spinePlusOne"));
        this._spineScatterPlus.visible = false;
        this.addChild(this._spineScatterPlus);
    }

    public enableGreenFrame():void {
        this._spineScatterGreenFrames.updateTransform();
        this._spineScatterGreenFrames.visible = true;
        this._spineScatterGreenFrames.skeleton.setSlotsToSetupPose();
        this._spineScatterGreenFrames.state.addAnimation(0, "bonus_anticipation_animation", true, 0);
    }

    public enableLevel3Scatter(playPlusThreeAnimation:boolean = false):void {
        if(this._level3Enabled == false && this._scatterLevel < 2) {
            this._scatterLevel = 3;
            this._level3Enabled = true;
            const level3TL:TimelineLite = new TimelineLite();
            level3TL.add(() => this.enableGreenFrame());
            level3TL.add(() => this.spineScatterSymbol.skeleton.setSlotsToSetupPose());
            level3TL.add([
                new SpineTween(this.spineScatterSymbol, 0, "bonus_anticipation_fire_puff_animation", 0),
                () => {
                    if(playPlusThreeAnimation == true) {
                        this.getPlusThreeAnimation();
                    } else {
                        this._yellowBlast.getAnimationAutoShowHide();
                    }
                }
            ]);
            level3TL.add(() => this.spineScatterSymbol.state.addAnimation(0, "bonus_anticipation_fire_loop_animation", true, 0));
        }
    }

    public disableGreenFrame():void {
        this._spineScatterGreenFrames.visible = false;
    }

    get scatterSymbol():StateReelSymbol {
        return this._scatterSymbol;
    }

    set scatterSymbol(value:StateReelSymbol) {
        this._scatterSymbol = value;
    }

    get yPos():number {
        return this.position.y;
    }

    set yPos(value:number) {
        this.position.y = value + this._symbolOffset.y;
    }

    get spineScatterSymbol():PIXI.spine.Spine {
        return this._spineScatterSymbol;
    }

    set spineScatterSymbol(value:PIXI.spine.Spine) {
        this._spineScatterSymbol = value;
    }

    public reset():void {
        this._level3Enabled = false;
        this._scatterLevel = 0;
        this._spineScatterPlus.visible = false;
    }

    public getPlusOneAnimation():TimelineLite {
        const plusOneTL:TimelineLite = new TimelineLite();
        plusOneTL.add(() => this._spineScatterPlus.updateTransform());
        plusOneTL.add(() => this._spineScatterPlus.visible = true);
        plusOneTL.add(() => this._spineScatterPlus.skeleton.setSkin(null));
        plusOneTL.add(() => this._spineScatterPlus.skeleton.setSkinByName("plusOne"));
        plusOneTL.add(() => this._spineScatterPlus.skeleton.setSlotsToSetupPose());
        plusOneTL.add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.FS_PLUS_SPIN)}));
        plusOneTL.add(new SpineTween(this._spineScatterPlus, 0, "animation", 0));
        plusOneTL.add(() => this._spineScatterPlus.visible = false, "+=0.5");

        return plusOneTL;
    }

    public getPlusThreeAnimation():TimelineLite {
        const plusOneTL:TimelineLite = new TimelineLite();
        plusOneTL.add(() => this._spineScatterPlus.updateTransform());
        plusOneTL.add(() => this._spineScatterPlus.visible = true);
        plusOneTL.add(() => this._spineScatterPlus.skeleton.setSkin(null));
        plusOneTL.add(() => this._spineScatterPlus.skeleton.setSkinByName("plusThree"));
        plusOneTL.add(() => this._spineScatterPlus.skeleton.setSlotsToSetupPose());
        plusOneTL.add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.SCATTER_3)}));
        plusOneTL.add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.FS_PLUS_SPIN)}));
        plusOneTL.add(new SpineTween(this._spineScatterPlus, 0, "animation", 0));
        plusOneTL.add(() => this._spineScatterPlus.visible = false, "+=0.5");

        return plusOneTL;
    }
}